import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Search } from 'lucide-react';
import { CourseList } from '../../components/courses/CourseList';
import { CourseFilters } from '../../components/courses/CourseFilters';
import { useCourseList } from '../../hooks/courses/useCourseList';

export function BrowseCoursesPage() {
  const { courses, isLoading } = useCourseList();
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedLevel, setSelectedLevel] = useState<string[]>([]);
  const [selectedDuration, setSelectedDuration] = useState<string[]>([]);

  const filteredCourses = courses.filter(course => {
    const matchesSearch = course.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         course.description.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesLevel = selectedLevel.length === 0 || selectedLevel.includes(course.level);
    const matchesDuration = selectedDuration.length === 0 || selectedDuration.includes(course.duration);
    
    return matchesSearch && matchesLevel && matchesDuration;
  });

  return (
    <div className="min-h-screen bg-background-dark py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6">
          <Link
            to="/dashboard"
            className="inline-flex items-center text-accent-green hover:opacity-80"
          >
            <ArrowLeft className="h-5 w-5 mr-2" />
            Back to Dashboard
          </Link>
        </div>

        <div className="mb-8">
          <h1 className="text-3xl font-bold text-white">Browse Courses</h1>
          <p className="mt-2 text-gray-400">
            Discover courses to advance your skills and career
          </p>
        </div>

        <div className="mb-6">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <input
              type="text"
              placeholder="Search courses..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-3 bg-background-card border border-gray-800 rounded-xl text-white placeholder-gray-400 focus:ring-2 focus:ring-accent-green focus:border-accent-green"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-3">
            <CourseFilters
              selectedLevel={selectedLevel}
              selectedDuration={selectedDuration}
              onLevelChange={setSelectedLevel}
              onDurationChange={setSelectedDuration}
            />
          </div>
          <div className="lg:col-span-9">
            <CourseList 
              courses={filteredCourses}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}